import IBKneeflexionatmidswing1 from '@/pages/ReportV2/components/Modals/assets/IBKneeflexionatmidswing1.png';
import IBKneeflexionatmidswing2 from '@/pages/ReportV2/components/Modals/assets/IBKneeflexionatmidswing2.png';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import { VerticalSwiper } from '@/components/swiper';

// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

export const KneeFlexionMidswingModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBKneeflexionatmidswing1} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  The difference in velocity between upper and lower leg, results in bending of the knee (due to its
                  mass, the lower leg will slow down). The more dynamic the push off is – emerging from proper
                  proximodistal sequence (also see: hip extension at terminal stance and knee extension at pre-swing) –
                  the more knee angle will be accomplished at midswing. The amount of angle is relevant for two major
                  reasons.
                  <br></br>
                  <br></br>
                  When the leg swings forward, the foot clearance must be sufficient to prevent stumbling due to
                  catching obstacles. The size of the knee angle determines to a significant extent the amount of foot
                  clearance. Given that the foot never leaves the ground more than 1 cm, it indicates how crucial
                  sufficient knee angle is.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid style={{ height: '100%' }}>
            <IonRow class='ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBKneeflexionatmidswing2} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  A knee flexing within healthy limits also ensures enough space (between body and ground) for the leg
                  to swing forward in a straight line under the body’s center of mass. A decreasing knee angle (&lt;
                  60°) limits the possibility for the leg to swing under the body. To prevent stumbling, the leg will
                  move forward around the body. The more this range of motion in frontal plane increases, the more
                  balance will be distorted.
                  <br></br>
                  <br></br>
                  It should be clear that in case of a hip drop (or Trendelenburg gait), the contralateral knee angle at
                  midswing will be compromised.
                  <br></br>
                  <br></br>
                  <strong>Causes low knee flexion at midswing</strong>
                  <ul>
                    <li>Reduced hip extension at terminal stance</li>
                    <li>Poor knee extension at pre-swing</li>
                    <li>Poor knee flexion / ankle plantar flexion at toe off</li>
                  </ul>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
